/* istanbul ignore file */
export const PRODUCT_MEDIA_TABPANEL_ID_PREFIX = 'product-media-tabpanel-';
export const PRODUCT_MEDIA_TABPANEL_CONTAINER_ID = 'product-media-tabpanel-container';
export const MEDIA_ID_PREFIX = 'fullscreen-';

export const ZOOM_PAN_WRAPPER_CLASS = 'zoom-pan-wrapper';
export const ZOOM_PAN_CONTENT_CLASS = 'zoom-pan-content';
export const PRODUCT_MEDIA_TABPANEL_CLASS = 'product-media__tabpanel';
